import $ from 'jquery';
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import vSelect from 'vue-select';
import "vue-select/dist/vue-select.css";
import { WindowType } from "../../../../util";
import { Card, CardDuration } from "../../../backend/backendapi";
import { KanbanState } from "../../kanban.model";

declare var window: WindowType;

@Component({
    name: 'MoveComponent',
    components: { vSelect }
})
export default class MoveComponent extends Vue {
    @Prop({ required: true })
    modalId!: string;
    @Prop({ required: true })
    state!: KanbanState;
    @Prop({ required: true })
    card!: Card;

    private hours: number = 0;
    private minutes: number = 0;
    private seconds: number = 0;
    private comment: string = '';
    private userId: string = '';

    mounted(): void { }

    openModal(): void {
        this.hours = 0;
        this.minutes = 0;
        this.seconds = 0;
        this.comment = '';
        this.userId = window.application.kanban.user?.id ?? '';
        $('#' + this.modalId).modal('show');
    }

    closeModal(): void {
        $('#' + this.modalId).modal('hide');
    }

    private get users(): { id: string, name: string }[] {
        return this.state.users.map(e => { return { id: e.id!, name: e.firstName! + ' ' + e.lastName }; });
    }

    private save(): void {
        let duration = new CardDuration();
        duration.cardId = this.card.id!;
        duration.userId = this.userId;
        duration.seconds = Math.round(this.hours * 60 * 60 + this.minutes * 60 + this.seconds);
        duration.comment = this.comment;
        this.$emit('save', duration);
    }
}